import { render, staticRenderFns } from "./ProductDescriptionInput.vue?vue&type=template&id=2bc5971a&"
import script from "./ProductDescriptionInput.vue?vue&type=script&lang=ts&"
export * from "./ProductDescriptionInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports